import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;


      private baseUrl = environment.apiUrl;
      private endpointBase = "/api/Visits/";
 

    constructor(private router: Router, private http: HttpClient) {
       
      }

    ngOnInit(){
        this.registerVisit()
        this.recallJsFuntions();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                window.history.pushState(null, '', window.location.href);
            }
        });
    }

    registerVisitObs(): Observable<any> {
        return this.http.post(this.baseUrl+this.endpointBase+"register_visits", {});
      }

    registerVisit() {
        const lastVisit = localStorage.getItem('lastVisit');
        const today = new Date().toISOString().split('T')[0]; 
      
        if (lastVisit !== today) {
          this.registerVisitObs().subscribe({
            next: (response) => {
              localStorage.setItem('lastVisit', today);
            },
            error: (error) => console.error('Error al registrar visita', error)
          });
        } 
      }
      
    
    recallJsFuntions() {
        if (this.routerSubscription) {
            return;
        }
    
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                $('.preloader').fadeIn('slow'); 
            }
        });
    
        // Manejo al finalizar navegación
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe((event) => {
                $('.preloader').fadeOut('slow'); 
                this.location = this.router.url;
    
                // Verificar si ya se cargó el script
                const existingScript = document.querySelector('script[src="../assets/js/custom.js"]');
                if (!existingScript) {
                    const script = document.createElement('script');
                    script.src = '../assets/js/custom.js';
                    script.async = true;
                    document.body.appendChild(script);
                }
    
                // Reiniciar scroll al cambiar la navegación
                if (event instanceof NavigationEnd) {
                    window.scrollTo(0, 0);
                }
            });
    }
    

}